import React from "react";
import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome icon
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import ProfileCardBase from "./ProfileCardBase/ProfileCardBase";

const MyLogCard: React.FC = () => {
  const { currentUser } = useLoginContext();

  if (isCompanyUser(currentUser) || !currentUser) return null;

  return (
    <ProfileCardBase
      title="Min logg"
      actionText="Se arrangementer"
      actionLink="/student-profile/my-log/"
      icon={faCalendarCheck} // Pass the FontAwesome icon directly
    >
      Her kan du se en oversikt over alle arrangementer du har vært påmeldt
    </ProfileCardBase>
  );
};

export default MyLogCard;
